import { TagMaster } from '@App/libs/components/jurisprudente-card/styles'
import { LogoItemCoberturasEspeciaisChild } from '@App/libs/interfaces/PRO.interfaces'
import { MD_PX, SM_PX } from '@App/libs/style/post-page'
import { BREAKPOINTS } from '@App/libs/utils/constants/layout'
import { useMediaQuery } from '@mui/material'
import Image from 'next/image'
import styled from 'styled-components'

type MasterSponsorsProps = {
    sponsors: LogoItemCoberturasEspeciaisChild[]
    label: string
}

export const PatrocinioMaster = 'Patrocínio Master'

const ImageSizeDesktop = 100
const ImageSizeMobile = 70

export const ListLogosCoberturas = ({
    sponsors,
    label
}: MasterSponsorsProps) => {
    const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.SM}px)`)

    if (!sponsors?.length) return null

    return (
        <LogosContainer>
            <TagContainerLogos>
                <TagMaster label={label}>
                    {label === PatrocinioMaster && (
                        <Image
                            src={'/images/Circle.svg'}
                            alt={'icon'}
                            width={16}
                            height={16}
                            style={{ borderRadius: '4px' }}
                        />
                    )}
                    <p>{label}</p>
                </TagMaster>
            </TagContainerLogos>

            <ListLogos label={label}>
                {sponsors.map((item, index) => {
                    const altText = item.name?.trim()
                        ? item.name
                        : `Sem nome ${index + 1}`

                    const srcImage = item.logo?.trim() || '/default-logo.png'

                    return (
                        <ImageContainerLogo key={`${altText}-${index}`}>
                            <Image
                                src={srcImage}
                                alt={altText}
                                width={
                                    isMobile
                                        ? ImageSizeMobile
                                        : ImageSizeDesktop
                                }
                                height={
                                    isMobile
                                        ? ImageSizeMobile
                                        : ImageSizeDesktop
                                }
                                style={{ border: 'none', height: 'auto' }}
                            />
                        </ImageContainerLogo>
                    )
                })}
            </ListLogos>
        </LogosContainer>
    )
}

const ImageContainerLogo = styled.div`
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid var(--Gray-jotaGrayLighter, #e6e8ed);
    background: var(--White-jotaWhite, #fff);

    @media (max-width: ${SM_PX}) {
        width: 80px;
        height: 80px;

        & > img {
            width: 70px;
            height: 70px;
        }
    }
`

const LogosContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const TagContainerLogos = styled.div``

const ListLogos = styled.div<{ label: string }>`
    display: ${(props) => (props.label === PatrocinioMaster ? 'grid' : 'flex')};
    grid-template-columns: ${(props) =>
        props.label === PatrocinioMaster ? 'repeat(4, 120px)' : 'none'};
    gap: 20px;
    flex-wrap: wrap;

    @media (max-width: ${MD_PX}) {
        display: flex;
    }
`
